import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject
} from '@angular/core';
import { FormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProposalRequestVendorForm } from 'src/app/classes/form-groups/proposal-request-vendor-form';
import { Company } from 'src/app/classes/models';
import { LocalizationInfo } from 'src/app/interfaces/localization-info';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-edit-proposal-request-vendor-modal',
  templateUrl: './edit-proposal-request-vendor-modal.component.html',
  styleUrl: './edit-proposal-request-vendor-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditProposalRequestVendorModalComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private ActiveModal: NgbActiveModal,
    private ToastService: ToastService,
    private UtilityService: UtilityService
  ) {}

  @Input() ProposalRequestVendorFormGroup!: ProposalRequestVendorForm;
  @Input() Company!: Company;

  title = 'Edit Vendor';
  ProposalRequestVendorFormArray = new FormArray<ProposalRequestVendorForm>([]);
  LocalizationInfo?: LocalizationInfo;
  country!: 'US' | 'CA';

  save() {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.ProposalRequestVendorFormArray
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'There is an error with a required field below.',
        { returnError: true }
      );
    }

    this.ActiveModal.close(this.ProposalRequestVendorFormGroup);
  }

  close() {
    this.ActiveModal.dismiss();
  }

  ngOnInit(): void {
    if (!this.ProposalRequestVendorFormGroup) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing bid request vendor information.',
        { returnError: true }
      );
    }

    if (!this.Company) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing client information.',
        { returnError: true }
      );
    }

    const { country } = this.Company;

    if (!country) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing country information.',
        { returnError: true }
      );
    }

    const {
      controls: {
        legalName: legalNameControl,
        dba: dbaControl,
        Address: {
          controls: {
            address1: address1Control,
            address2: address2Control,
            city: cityControl,
            state: stateControl,
            zip: zipControl
          }
        }
      }
    } = this.ProposalRequestVendorFormGroup;

    [
      legalNameControl,
      dbaControl,
      address1Control,
      address2Control,
      cityControl,
      stateControl,
      zipControl
    ].forEach((control) => {
      control.disable();
    });

    this.country = country;
    this.ProposalRequestVendorFormArray.push(
      this.ProposalRequestVendorFormGroup
    );
    this.LocalizationInfo = this.UtilityService.getLocalizedValuesMap(country);
    this._cdr.markForCheck();
  }
}
